export default __webpack_public_path__ + "static/media/Here-For-You.0ce97c11.svg";